/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TasksAliases {
  AUTOCOMPLETE_PROVIDER = 'autocomplete-provider',
  AVATAR_0 = 'avatar-0',
  CARD_TASK = 'card-task',
  CHECKBOX_0 = 'checkbox-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_TASKS = 'deck-tasks',
  FETCH_LOCATOR = 'fetch-locator',
  FETCH_TASKS = 'fetch-tasks',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_ALERT = 'field-alert',
  FIELD_LOCATOR = 'field-locator',
  FIELD_PENDING = 'field-pending',
  FILTER_TASKS = 'filter-tasks',
  FILTERED_LIST_0 = 'filtered-list-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_2 = 'mapper-2',
  MAPPER_AUTOCOMPLETE = 'mapper-autocomplete',
  PANEL_TASKS = 'panel-tasks',
  PROGRESS_BAR_0 = 'progress-bar-0',
  TEXT_AUTOCOMPLETE = 'text-autocomplete',
}
export { TasksAliases };
